import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    sourceSelector,
    destinationSelector,
} from "../../../../common/redux/selector";
import { 
    reviewsSelector, 
    faqSelector, 
    topRoutesFromSourceSelector, 
    topRoutesFromSourceTitleSelector, 
    topRoutesToDestinationSelector, 
    topRoutesToDestinationTitleSelector, 
    lpgSelector, 
    waySelector, 
    airportTypeSelector, 
    staticTableDetails, 
    staticRentalTableDetails, 
    seoCarTypeSelector 
} from '../../redux/selector';
import TopRoutes from '../../../../../stories/components/cars/SeoPage/TopRoutes/TopRoutesWrapper';
import Faq from '../../../../../stories/components/cars/SeoPage/Faq/FaqUI';
import Reviews from '../../../../../stories/components/cars/SeoPage/Reviews/Reviews';
import useNavigate from '../../../../hooks/useNavigate';
import { capitalizeFirstLetter } from '../../../../config/utils';
import SeoRentalTableDetails from '../SeoRentalTableDetails/SeoRentalTableDetails';
import SeoRentalStaticTable from '../SeoRentalStaticTable/SeoRentalStaticTable';
import { WAY_TYPE_IN, WAY_TYPE_FROM } from '../../../../../shared/config/constants';
import { UPDATE_DESTINATION, UPDATE_SOURCE } from '../../../../common/redux/action-types';

export default function() {
    const [viewMoreReviews, setViewMoreReviews] = useState(true);
    const reviews = useSelector(reviewsSelector);
    const faqs = useSelector(faqSelector);
    const carType = useSelector(seoCarTypeSelector)
    const topRoutesFromSource = useSelector(topRoutesFromSourceSelector);
    const topRoutesFromSourceTitle = useSelector(topRoutesFromSourceTitleSelector);
    const topRoutesToDestination = useSelector(topRoutesToDestinationSelector);
    const topRoutesToDestinationTitle = useSelector(topRoutesToDestinationTitleSelector);
    const source = useSelector(sourceSelector);
    const destination = useSelector(destinationSelector);
    const lpg = useSelector(lpgSelector);
    const way = useSelector(waySelector);
    const airportType = useSelector(airportTypeSelector);
    const staticTableData = useSelector(staticTableDetails)
    const rentalData = useSelector(staticRentalTableDetails)

    const dispatch = useDispatch();
    const [navigateTo] = useNavigate();

    const parseRoutes = (routes) => {
        if (routes && routes?.length > 0) {
            return routes.map((route) => {
                // const newUrl = route?.url ? route.url.split("https://www.goibibo.com")[1] : '';
                return {
                    title: route?.title ? route.title : (route?.source && route?.destination ? `${capitalizeFirstLetter(route?.source)} to ${capitalizeFirstLetter(route?.destination)} cabs` : ''),
                    subtitle: route?.distance && route?.approx_time ? `${route?.distance} kms | ${route?.approx_time} (appx.)` : '',
                    includedDistance: route?.included_distance ? `${route?.included_distance} kms included` : '',
                    extraFare: route?.extra_fare && route?.distance ? `Extra fare ₹${route?.extra_fare}/km after ${route?.distance} kms` : '',
                    startingPrice: route?.starting_price,
                    src_id: route?.source_city_id,
                    dest_id: route?.destination_city_id,
                    source: route?.source,
                    destination: route?.destination,
                    isLPG: !!route?.isLPG,
                    toolTip: !!route?.isLPG ? lpg : {},
                    car_types: route?.car_types || "",
                    img_url: route?.img_url || "",
                    vehicle_key: route?.vehicle_key || "",
                    car_types_subtitle: route?.car_types_subtitle || "",
                    d_s: route?.d_S || "",
                    link: route?.url ? route.url : (route?.source && route?.destination ? `${__ENV_CONFIG__['__GOIBIBO__']}/cars/${route?.source}-to-${route?.destination}-cabs/` : "")
                    // link: route?.url ? `${__ENV_CONFIG__['__GOIBIBO__']}${newUrl}` : (route?.source && route?.destination ? `${__ENV_CONFIG__['__GOIBIBO__']}/cars/${route?.source}-to-${route?.destination}-cabs/` : "")
                }
            })
        }
        return [];
    }

    const routeAction = (route) => {
        const source = {
            name: capitalizeFirstLetter(route?.source),
            place_id: route?.src_id,
            city_name: ''
        }
        const destination = {
            name: capitalizeFirstLetter(route?.destination),
            place_id: route?.dest_id,
        }
        dispatch({
            type: UPDATE_SOURCE,
            source
        });
        dispatch({
            type: UPDATE_DESTINATION,
            destination
        })
        navigateTo('srp', true);
    }

    const getTopRoutes = () => {
        if (way) {
            let topRouteSubHeading = carType ? `${carType} Cab` : `Cab`
            let topRouteHeadingPart1 = `to ${destination?.name}`
            let topRouteHeadingPart2 = `from ${destination?.name}`
            if(way === WAY_TYPE_FROM || (way === WAY_TYPE_IN && carType)){
                topRouteHeadingPart1 = `from ${source?.name}`
                topRouteHeadingPart2 = `to ${source?.name}`
            }
            return (
                <>
                    <TopRoutes
                        routes={parseRoutes(way === WAY_TYPE_FROM || (way === WAY_TYPE_IN && carType) ? topRoutesFromSource : topRoutesToDestination)}
                        title={topRoutesFromSourceTitle}
                        onAction={(route) => routeAction(route)}
                        isCarType={false}
                        subtitle={`${topRouteSubHeading} ${topRouteHeadingPart1}`}
                    />
                    <TopRoutes
                        routes={parseRoutes(way === WAY_TYPE_FROM || (way === WAY_TYPE_IN && carType) ? topRoutesToDestination : topRoutesFromSource)}
                        title={topRoutesToDestinationTitle}
                        onAction={(route) => routeAction(route)}
                        isCarType={false}
                        subtitle={`${topRouteSubHeading} ${topRouteHeadingPart2}`}
                    />
                </>
            );
        }
        if (airportType) {
            return (
                <>
                    <TopRoutes
                        routes={parseRoutes(topRoutesFromSource)}
                        title={topRoutesFromSourceTitle}
                        onAction={(route) => routeAction(route)}
                        isCarType={false}
                        subtitle={`Cab from ${airportType === 'ac' ? source?.name : destination?.name}`}
                    />
                    <TopRoutes
                        routes={parseRoutes(topRoutesToDestination)}
                        title={topRoutesToDestinationTitle}
                        onAction={(route) => routeAction(route)}
                        isCarType={false}
                        subtitle={`Cab to ${airportType === 'ac' ? source?.name : destination?.name}`}
                    />
                </>
            );
        }
        return (
            <>
                <TopRoutes
                    routes={parseRoutes(topRoutesFromSource)}
                    title={topRoutesFromSourceTitle}
                    onAction={(route) => routeAction(route)}
                    isCarType={false}
                    subtitle={`Cab from ${source?.name}`}
                />
                <TopRoutes
                    routes={parseRoutes(topRoutesToDestination)}
                    title={topRoutesToDestinationTitle}
                    onAction={(route) => routeAction(route)}
                    isCarType={false}
                    subtitle={`Cab to ${destination?.name}`}
                />
            </>
        );
    }

    return (
        <div>
            {getTopRoutes()}
            {rentalData?.length ? (
                <SeoRentalTableDetails rentalData={rentalData}/>
            ) : null}
            <Faq faqHeading={faqs?.faq_heading} faqData={faqs?.faq_content} />
            {staticTableData?.length ? (
                <SeoRentalStaticTable staticTableDetails={staticTableData}/>
            ) : null}
            
            <Reviews
                reviews={viewMoreReviews ? reviews.slice(0,2) : reviews}
                viewMore={viewMoreReviews}
                onViewMore={() => setViewMoreReviews(!viewMoreReviews)}
                showCollapsed={!!(reviews?.length > 2)}
            />
        </div>
    )
}